export const DEFAULT_SCENE = 'schedule-adherence:settings';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;

export const ADD_SETTING_BUTTON_TAG = `${DEFAULT_SCENE}:button-add`;
export const SAVE_SETTING_BUTTON_TAG = `${DEFAULT_SCENE}:button-save`;
export const CANCEL_SETTING_BUTTON_TAG = `${DEFAULT_SCENE}:button-cancel`;

export const NOTIFICATION_SETTINGS_BUTTON_TAG = `${DEFAULT_SCENE}:button-notification`;
export const ADD_NOTIFICATION_SETTINGS_BUTTON_TAG = `${DEFAULT_SCENE}:button-add-notification`;
export const SAVE_NOTIFICATION_SETTINGS_BUTTON_TAG = `${DEFAULT_SCENE}:button-save-notification`;
export const CANCEL_NOTIFICATION_SETTINGS_BUTTON_TAG = `${DEFAULT_SCENE}:button-cancel-notification`;

const LIST = `${DEFAULT_SCENE}:list`;
export const LIST_CONTAINER_TAG = `${LIST}:container`;
export const getListHeaderTag = (headerName: string) => `${LIST}:header-${headerName}`;
export const getListItemTag = (order: number, propName: string) => `${LIST}:setting[${order}]-${propName}`;

export const getFieldsInputTag = (fieldName: string) => `${DEFAULT_SCENE}:input-${fieldName}`;

export const LIST_PAGINATION_TAG = `${LIST}:pagination`;
